import React from 'react';
import { Shield, TrendingUp, AlertTriangle, CheckCircle } from 'lucide-react';
import { CoverageHero } from '../components/CoverageHero';
import { CoverageCTA } from '../components/CoverageCTA';

const Annuities = () => {
  return (
    <div className="min-h-screen">
      <CoverageHero
        title="Annuity Options for Retirement Income and Financial Confidence"
        subtitle="Plan your retirement with purpose. Explore fixed and indexed annuity options designed to help provide income in retirement, protect your savings, and build a lasting legacy."
      />
      <section className="py-8">
        <div className="container mx-auto px-4"><div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-6">What Are Annuities?</h2>
            <p className="text-lg text-gray-700 leading-relaxed">Annuities are long-term insurance products designed to help you accumulate savings and convert them into a steady stream of income during retirement.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {[{icon:Shield,title:"Fixed Annuities",desc:"Earn a guaranteed interest rate. Principal is protected and growth is predictable.",color:"border-brand-blue",bg:"bg-brand-blue"},{icon:TrendingUp,title:"Fixed Indexed Annuities",desc:"Earn interest based on market index performance with a floor to protect against losses.",color:"border-brand-orange",bg:"bg-brand-orange"},{icon:CheckCircle,title:"Retirement Income",desc:"Convert savings into guaranteed income payments for a specific period or for life.",color:"border-brand-blue",bg:"bg-brand-blue"},{icon:Shield,title:"Legacy Planning",desc:"Some annuities include death benefit provisions for your beneficiaries.",color:"border-brand-orange",bg:"bg-brand-orange"}].map(({icon:Icon,title,desc,color,bg})=>(<div key={title} className={`bg-white border-t-4 ${color} rounded-lg p-6 shadow-md`}><div className={`${bg} text-white w-14 h-14 rounded-full flex items-center justify-center mb-4`}><Icon size={28}/></div><h3 className="text-xl font-bold text-brand-blue mb-3">{title}</h3><p className="text-gray-700">{desc}</p></div>))}
          </div>
        </div></div>
      </section>
      <section className="py-8">
        <div className="container mx-auto px-4"><div className="max-w-4xl mx-auto">
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-r-lg">
            <div className="flex items-start gap-3">
              <AlertTriangle className="text-yellow-600 flex-shrink-0 mt-1" size={24}/>
              <div><h3 className="font-bold text-lg text-yellow-800 mb-2">Important Disclosure</h3><p className="text-gray-700 text-sm leading-relaxed">Annuities are long-term insurance products. Features, surrender charges, guarantees, and income options vary by product and carrier.</p></div>
            </div>
          </div>
        </div></div>
      </section>
      <CoverageCTA
        heading="Schedule an Annuity Review"
        subtext="Plan your retirement with purpose. Speak with a licensed representative at Purposefully Covered Insurance Group today."
      />
    </div>
  );
};

export default Annuities;
